<template>
  <div class="sidebar">
    <el-scrollbar style="overflow: hidden; height: 100%">
      <Menus />
    </el-scrollbar>
  </div>
</template>
<script>
import Menus from "../Menus/index.vue";
export default {
  name: "SideBar",
  components: { Menus },
  data() {
    return {};
  },
  computed: {},
  methods: {
    handleOpen() {},
    handleClose() {},
  },
};
</script>
<style lang="less" scoped>
.sidebar {
  // height: 100%;
  flex: 1 1 0;
  overflow: hidden;
  user-select: none;
  ::v-deep .el-scrollbar__wrap {
    overflow: hidden scroll;
  }
}
</style>
